import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 31px;
  .rankmiTable-rowsCount {
    margin-bottom: 4px;
  }
  .ant-tag {
    height: 32px;
  }
  .rankmiTable-container {
    > div + div + div {
      justify-content: flex-end;
    }
  }
`
